import styled from 'styled-components';

const LastCell = styled.div`
    min-width: 50px;
`;

export default LastCell;



// WEBPACK FOOTER //
// ./src/components/list/Filters/layout/LastCell.js